import axios from 'axios'

const endPoint = '/coach-dashboard/dashboard'

export function getItems({ commit, state }, props) {

    let params = {
        sortBy: props.pagination.sortBy,
        descending: props.pagination.descending,
        page: props.pagination.page,
        rowsPerPage: props.pagination.rowsPerPage,
        search: props.filter?.search
    }

    return new Promise((resolve, reject) => {
        axios
            .get(endPoint, {
                params: params
            })
            .then(response => {
                resolve(response)
            })
            .catch(err => {
                reject(err)
            })
    })
}
export function avgData ({ commit, state },props){
    return new Promise((res, rej) => {
        axios.get(`/coach-dashboard/overall-dashboard`, {params: props})
            .then((response) => {
                commit('setAvgData', response.data)
                res(response);
            })
            .catch((err) => {
                rej(err);
            })
    })
}


export function getCustomer (data,props){
    return new Promise((res, rej) => {
        axios.get(`company`, {params: props})
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
}